/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SVGIcons } from "cms/icons/svg-icons";
import React from "react";

export const formatBytes = function (bytes, decimals = 1) {
    if (!+bytes) {
        return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const getIconForType = (type) => {
    switch (type) {
        case "application/pdf":
            return <span className='color-pdf'><SVGIcons.files.PdfFile/></span>;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            return <span className='color-msword'><SVGIcons.files.WordFile/></span>;
        case "application/msword":
            return <span className='color-msword'><SVGIcons.files.WordFile/></span>;
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        case "application/vnd.ms-excel":
            return <span className='color-excel'><SVGIcons.files.ExcelFile/></span>;
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
            return <span className='color-powerpoint'><SVGIcons.files.PowerpointFile/></span>;
        case "text/plain":
            return <span className='color-text'><SVGIcons.files.TextLinesFile/></span>;
        case "text/csv":
            return <span className='color-csv'><SVGIcons.files.CsvFile/></span>;
        case "text/xml":
            return <span className='color-xml'><SVGIcons.files.XmlFile/></span>;
        case "application/x-zip-compressed":
            return <span className='color-zip'><SVGIcons.files.ZipFile/></span>;
        case "application/json":
            return <span className='color-json'><SVGIcons.files.CodeFile/></span>;
        case "text/calendar":
            return <span className='color-calendar'><SVGIcons.files.TextLinesFile/></span>;
        case "image/png":
            return <span className='color-png'><SVGIcons.files.ImageFile/></span>;
        case "image/jpeg":
            return <span className='color-jpeg'><SVGIcons.files.ImageFile/></span>;
        case "video/mp4":
            return <span className='color-mp4'><SVGIcons.files.VideoFile/></span>;
        case "video/quicktime":
            return <span className='color-quicktime'><SVGIcons.files.VideoFile/></span>;
        case "image/svg+xml":
            return <span className='color-svg'><SVGIcons.files.ImageFile/></span>;
        default:
            return <span className='color-default'><SVGIcons.files.QuestionFile/></span>;
    }
};

export const getCleanFileType = (type, file_ext) => {
    switch (type) {
        case "application/pdf":
            return `PDF document (.${file_ext})`;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            return `Word document (.${file_ext})`;
        case "application/msword":
            return `Word document (.${file_ext})`;
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        case "application/vnd.ms-excel":
            return `Excel spreadsheet (.${file_ext})`;
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
            return `Powerpoint document (.${file_ext})`;
        case "text/plain":
            return `Text file (.${file_ext})`;
        case "text/csv":
            return `CSV file (.${file_ext})`;
        case "text/xml":
            return `XML file (.${file_ext})`;
        case "application/x-zip-compressed":
            return `ZIP file (.${file_ext})`;
        case "application/json":
            return `JSON file (.${file_ext})`;
        case "image/png":
            return `PNG Image (.${file_ext})`;
        case "image/jpeg":
            return `JPEG Image (.${file_ext})`;
        case "video/mp4":
            return `MP4 Video (.${file_ext})`;
        case "video/quicktime":
            return `QuickTime Video (.${file_ext})`;
        case "image/svg+xml":
            return `SVG XML (.${file_ext})`;
        default:
            return `Unknown (.${file_ext})`;
    }
};
